import { useI18n } from '@/hooks/useI18n';
import { useAuthenticated } from '@gettactic/hooks';
import { format } from 'date-fns';

export const useDateFormat = () => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const { templates } = useI18n(authenticatedUser);

  return (date: Date | null | undefined) => {
    return date ? format(date, templates.displayDateWordy) : '';
  };
};
